var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup47219(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8945_313",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 123,
    height: 123
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 61.5,
    r: 61.5,
    fill: "#C3EEFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8945_313)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8945_313)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.1848,
    cy: 31.2331,
    rx: 72.3391,
    ry: 59.8506,
    fill: "#CCB8EF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_8945_313)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.97,
    cy: -4.81398,
    rx: 72.3391,
    ry: 59.8506,
    fill: "#FEDEFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_8945_313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.3356 3.16438C19.1242 17.1979 10.0437 41.6879 10.0437 86.8154C-14.9555 86.8154 -32.1946 29.8353 -32.1946 3.16438C-32.1946 -23.5065 -11.9287 -45.1276 13.0705 -45.1276C38.0697 -45.1276 58.3356 -23.5065 58.3356 3.16438Z",
    fill: "#FEDEFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8945_313",
    x: -63.6554,
    y: -85.1186,
    width: 257.68,
    height: 232.703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.2506,
    result: "effect1_foregroundBlur_8945_313"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_8945_313",
    x: -5.87026,
    y: -121.166,
    width: 257.68,
    height: 232.703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.2506,
    result: "effect1_foregroundBlur_8945_313"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_8945_313",
    x: -58.378,
    y: -71.311,
    width: 142.897,
    height: 184.31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.0917,
    result: "effect1_foregroundBlur_8945_313"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup47219);
export default __webpack_public_path__ + "static/media/Group 47219.7168aaeb1d54f72567768c917c454083.svg";
export { ForwardRef as ReactComponent };